import { createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'react-router-redux';
import { createBrowserHistory } from 'history';
import { configUtils } from '../config';
import createRootReducer from './combineReducers';
import sagas from './sagas';

const sagaMiddleware = createSagaMiddleware();

const loggerMiddleware = createLogger({
  predicate: () => configUtils.isReduxLogginEnabled(),
  diff: false, // setting true causes tab to freeze
});

export const history = createBrowserHistory({ basename: '/3d' });

const routerMW = routerMiddleware(history);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default createStore(
  createRootReducer(history),
  composeEnhancers(applyMiddleware(routerMW, sagaMiddleware, loggerMiddleware)),
);

sagaMiddleware.run(sagas);
